export const rememberPasswordOption = [
  {
    label: 'Remember password?',
    value: true
  }
];
